const FEATURE_HELP_URLS = {
  agent_bots: 'https://automatizacomia.com.br',
  agents: 'https://automatizacomia.com.br',
  audit_logs: 'https://automatizacomia.com.br',
  campaigns: 'https://automatizacomia.com.br',
  canned_responses: 'https://automatizacomia.com.br',
  channel_email: 'https://automatizacomia.com.br',
  channel_facebook: 'https://automatizacomia.com.br',
  custom_attributes: 'https://automatizacomia.com.br',
  dashboard_apps: 'https://automatizacomia.com.br',
  help_center: 'https://automatizacomia.com.br',
  inboxes: 'https://automatizacomia.com.br',
  integrations: 'https://automatizacomia.com.br',
  labels: 'https://automatizacomia.com.br',
  macros: 'https://automatizacomia.com.br',
  reports: 'https://automatizacomia.com.br',
  sla: 'https://automatizacomia.com.br',
  team_management: 'https://automatizacomia.com.br',
  webhook: 'https://automatizacomia.com.br',
  billing: 'https://automatizacomia.com.br',
  saml: 'https://automatizacomia.com.br',
  captain_billing: 'https://automatizacomia.com.br',
  captain: 'https://automatizacomia.com.br',
  whatsapp_templates: 'https://automatizacomia.com.br',
  shopify: 'https://automatizacomia.com.br',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
